var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive },
  ]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('user-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'dashboard',
          path: '/dashboard',
        }}}),(_vm.hasRoles(['reviewer']))?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.review_management'), icon: 'book' }}},[(_vm.hasRoles(['reviewer']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.review_status'),
            path: '/reviews/status',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasRoles(['editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.final_review_management'),
          icon: 'pageview',
        }}},[(_vm.hasRoles(['editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.final_review_status'),
            path: '/final-reviews/status',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasRoles(['editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.reviewer_management'),
          icon: 'manage_accounts',
        }}},[(_vm.hasRoles(['editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.reviewer_management_add_and_delete'),
            path: '/reviewers/managements',
          }}}):_vm._e(),(_vm.hasRoles(['editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.reviewer_management_assignment'),
            path: '/reviewers/assignments',
          }}}):_vm._e()],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.payment_management'),
          icon: 'account_balance_wallet',
        }}},[_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.payment_history'), path: '/payments' }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.payment_fee'), path: '/payments/fee' }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.payment_donation'),
            path: '/payments/donation',
          }}})],1),(_vm.hasType(['REGULAR', 'ADMIN']))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.submission_management'),
          icon: 'edit_square',
        }}},[(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.submission_all_status'),
            path: '/submissions/all',
          }}}):_vm._e(),(_vm.hasType(['REGULAR', 'ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.my_submission'),
            path: '/submissions/status',
          }}}):_vm._e()],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.board'), icon: 'front_hand' }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.announcement'),
            path: '/posts/announcements',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.member_news'),
            path: '/posts/membernews',
          }}})],1),(_vm.hasRoles(['member', 'master']))?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.member_management'), icon: 'groups' }}},[(_vm.hasRoles(['member', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.member_info'),
            path: '/members/management',
          }}}):_vm._e(),(_vm.hasRoles(['member', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.member_approval'),
            path: '/members/approval-reqeust',
          }}}):_vm._e(),(_vm.hasRoles(['master', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.admin_management'),
            path: '/members/admin-management',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasRoles(['account', 'master']))?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.account_management'), icon: 'paid' }}},[(_vm.hasRoles(['account', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.payment_history'),
            path: '/accounts/payments',
          }}}):_vm._e(),(_vm.hasRoles(['account', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.fee_type_management'),
            path: '/accounts/fee-types',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasRoles(['content', 'master']))?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.content_management'), icon: 'toc' }}},[(_vm.hasRoles(['content', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.homepage_management'),
            path: '/contents/home',
          }}}):_vm._e(),(_vm.hasRoles(['content', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.announcement_management'),
            path: '/contents/announcements',
          }}}):_vm._e(),(_vm.hasRoles(['content', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.membernews_management'),
            path: '/contents/member-news',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasRoles(['content', 'editor', 'master']))?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.journal_management'), icon: 'book' }}},[(_vm.hasRoles(['content', 'editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.journal_list'),
            path: '/journals/management',
          }}}):_vm._e(),(_vm.hasRoles(['content', 'editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.consent_document_management'),
            path: '/journals/consent-documents/management',
          }}}):_vm._e(),(_vm.hasRoles(['content', 'editor', 'master']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.journal_archive_management'),
            path: '/journals/archives',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.admin_page'), icon: 'key' }}},[(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.conference_management'),
            path: '/conferences',
          }}}):_vm._e(),(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.conference_archive_management'),
            path: '/admin/conference/archives',
          }}}):_vm._e(),(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.conference_gallery_management'),
            path: '/admin/conference/gallery',
          }}}):_vm._e(),(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.member_archive_management'),
            path: '/admin/member/archives',
          }}}):_vm._e(),(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.mail_template_management'),
            path: '/mail-template',
          }}}):_vm._e(),(_vm.hasType(['ADMIN']))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.admin_archive_management'),
            path: '/admin/archives',
          }}}):_vm._e()],1):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }